import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Typography, FormGroup, FormControl, FormLabel, FormControlLabel, Checkbox, Button, Tooltip, Box, CircularProgress } from '@material-ui/core';
import { green, grey, red, yellow } from '@material-ui/core/colors';
import { toastr } from 'react-redux-toastr';
import { URL } from '../../assets/js/constants';

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';

import { getNotificacoesPush } from '../../store/actions/notificacoesPush';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';

const Notificacoes = props => {
    const history = useHistory();
    const {
        user,
        notificacoesPush,
        getNotificacoesPush,
        loading
    } = props;
    const { perfis } = user;

    useEffect(_ => {
        getNotificacoesPush();
    }, [getNotificacoesPush]);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Título',
            selector: (row) => row.titulo,
            sortable: true,
        },
        {
            name: 'Mensagem',
            selector: (row) => row.conteudo,
            width: '250px',
            sortable: true,
        },
        {
            name: <>Qtde de <br />Destinos</>,
            selector: (row) => row.quantidadeDispositivosDestino,
            center: 'true',
            width: '90px',
            headerStyle: { whiteSpace: 'normal' },
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (
                row.status === 'SENT' ?
                    <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon>
                    : row.status === 'FAILED' ?
                        <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
                        : row.status === 'PENDING' ?
                            <Icon fontSize='small' style={{ color: grey[500] }}>hourglass_empty</Icon>
                            : null
            ),
            width: '80px',
        },
        {
            name: 'Data do Envio',
            selector: (row) => row.instante,
            width: '160px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Detalhar Notificação' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="detalhar" size='small' color='secondary' onClick={() => handleDetalharNotificacao(row.id)}><SearchOutlinedIcon /></IconButton>
                    </Tooltip>

                </>
            ),
            width: '80px'
        }
    ];

    const handleDetalharNotificacao = (id) => {
        history.push({
            pathname: '/notificacoes-push/detalhar-notificacao',
            state: {
                notificacaoId: id
            },
        });
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Notificações Push' subtitulo={new Date().toLocaleString('pt-BR')} />

            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={notificacoesPush}
                    visibleSearch={notificacoesPush && notificacoesPush.length > 0}
                    camposParaBusca={['titulo', 'id']}
                />
                <Grid container>
                    <Button variant='contained' color='secondary' href='/notificacoes-push/cadastrar-notificacao'>Nova Notificação</Button>
                </Grid>
            </Box>
        </>
    )
}

const mapStateToProps = state => ({
    user: state.auth.user,
    notificacoesPush: state.notificacoesPush.notificacoesPush,
    loading: state.notificacoesPush.loading,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getNotificacoesPush,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Notificacoes);